import type { ReactNode } from 'react';

export function App({ children }: { children: ReactNode }) {
  return <div className="min-h-screen">{children}</div>;
}
